import { useQuery } from '@tanstack/react-query';
import { isNil } from 'lodash';
import { FirmsService } from 'api';

export const GENERATION_EFFORT_OPTIONS_QUERY_KEY = 'GENERATION_EFFORT_OPTIONS';

// SCAL-9352: the server decides what this user may see (which efforts, whether
// the selector shows at all, model names, advanced models), so the hook is a
// thin passthrough - no client-side role or tier logic.
export const useGenerationEffortOptions = (firmId?: number | null) =>
  useQuery({
    enabled: !isNil(firmId),
    queryFn: () => FirmsService.apiFirmsGenerationEffortOptionsList(String(firmId)),
    queryKey: [GENERATION_EFFORT_OPTIONS_QUERY_KEY, firmId],
  });
